module.exports = __webpack_public_path__ + "static/media/1996.9ca2d7e5.svg";